<template>
  <b-dropdown
    class="templates-notifications"
    variant="link"
    toggle-class="text-decoration-none"
    right
    @show="makeRead"
  >
    <template #button-content>
      <i class="icon-bell text-light"></i>
      <div class="unread-number" v-if="unread.length">{{ unread.length }}</div>
    </template>

    <action-dispatcher
      action="notifications/getAll"
      class="templates-notifications notifications-content"
    >
      <b-dropdown-text class="px-3">
        <strong class="text-light">Notificações</strong>
      </b-dropdown-text>
      <b-dropdown-text
        v-if="notifications.length === 0"
        class="px-3 text-light"
      >
        <em>Nenhuma notificação</em>
      </b-dropdown-text>
      <b-dropdown-item
        v-for="(n, i) in notifications"
        :key="i"
        @click="clickNotification(n)"
        class="my-2"
      >
        <div
          v-if="['broadcast', 'direct'].includes(n.type)"
          class="content"
          :class="{ 'font-weight-bold': !n.read }"
        >
          <strong class="text-light">{{ title(n) }}</strong>
          <small>{{ stripHtml(n.message) }}</small>
        </div>
        <div v-if="!n.read" class="unread-icon"></div>
        <b-dropdown-divider />
      </b-dropdown-item>
    </action-dispatcher>

    <b-modal v-model="dialog" hide-header hide-footer centered>
      <div class="p-3 text-light">
        <h5 class="mb-4">{{ titles }}</h5>
        <div v-html="message" />
      </div>
    </b-modal>
  </b-dropdown>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      message: "",
      titles: ""
    };
  },
  computed: {
    ...mapState("notifications", ["notifications"]),
    unread() {
      return this.notifications.filter(n => !n.read).map(n => n.id);
    }
  },
  methods: {
    makeRead() {
      this.$store
        .dispatch("notifications/makeRead", this.unread)
        .finally(() => {
          this.$store.dispatch("notifications/getAll");
        });
    },
    clickNotification(n) {
      if (["broadcast", "direct"].includes(n.type)) {
        this.message = n.message;
        this.titles = this.title(n);
        this.dialog = true;
      }
    },
    stripHtml(html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
    title(n) {
      if (n && n?.title) {
        return n.title;
      } else {
        return "Mensagem recebida";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.templates-notifications {
  em {
    color: rgba(0, 0, 0, 0.6);
    font-size: 14px;
  }

  &.notifications-content {
    max-height: 30vh;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track-piece {
      background-color: transparent;
      //border-left: 1px solid #ccc;
    }
    &::-webkit-scrollbar-thumb:vertical {
      background-color: #49a6ca;
      border-radius: 25px;
    }
  }
  @media screen and (min-width: 576px) {
    i {
      font-size: 28px !important;
    }
  }

  .content {
    strong {
      display: block;
      font-size: 14px;
      line-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    small {
      display: block;
      font-size: 10px;
      line-height: 12px;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #9a9a9a;
      padding-bottom: 4px;
    }
  }

  .unread-number {
    font-weight: bold;
    font-size: 10px;
    line-height: 10px;
    min-height: 16px;
    max-height: 16px;
    min-width: 16px;
    max-width: 16px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgb(255, 100, 100);
    color: black;
    position: absolute;
    bottom: 2px;
    right: 2px;
  }

  ::v-deep .dropdown-item {
    position: relative;
    padding: 6px 16px;
  }

  ::v-deep .dropdown-toggle::after {
    display: none;
  }

  .unread-icon {
    border-radius: 8px;
    min-height: 8px;
    max-height: 8px;
    min-width: 8px;
    max-width: 8px;
    background: #4e3d90;
    position: absolute;
    top: 50%;
    right: 4px;
    transform: translateY(-50%);
  }

  i {
    font-size: 24px;

    @media screen and (max-width: 575px) {
      font-size: 20px;
    }
  }
}
</style>
